module.exports = __webpack_public_path__ + "ef561b564642c8b1bddda2a99b8e08d6.svg";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/pages/GamesPageNewLayout/assets/resetIcon.svg
// module id = 1785
// module chunks = 2